import React from 'react'

import Text from '../Text'
import Media from '../Media'
import Ctas from '../Ctas'
import Section from '../Section/Section'

import classNames from 'classnames'
import {
  hero,
  content,
  background,
  isFullMobile,
  isFullDesktop,
} from './hero.module.scss'

export default function Hero({
  hat,
  hatAs = 'h4',
  title,
  subtitle,
  titleAs = 'h1',
  subtitleAs = 'body1',
  media,
  className,
  mediaClassName,
  ctas,
  options,
  customCta: CustomCta,
  fullMobile = false,
  fullDesktop = false,
  loading,
  timeStamp,
}) {
  return (
    <Section
      className={classNames(hero, className, {
        [isFullMobile]: fullMobile,
        [isFullDesktop]: fullDesktop,
      })}
    >
      {media && (
        <Media
          loading={loading}
          {...media}
          timeStamp={timeStamp}
          className={classNames(background, mediaClassName)}
        />
      )}

      <div className={classNames(content, 'hero-content')}>
        <Text
          hat={hat}
          hatAs={hatAs}
          title={title}
          subtitle={subtitle}
          titleAs={titleAs}
          subtitleAs={subtitleAs}
        />
        {ctas && <Ctas ctas={ctas} options={options} />}
        {CustomCta && <CustomCta />}
      </div>
    </Section>
  )
}
